var React = require('react');

function Minus24x24 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Color=Black, State=Minus, Size=24x24"},React.createElement("path",{"id":"Vector","d":"M12 12v.001m0 0h12m-12 0H0","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round"})));
}

Minus24x24.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Minus24x24;

Minus24x24.default = Minus24x24;
